module.exports = __webpack_public_path__ + "static/32-5c7d4448391c59f9472a17750ddcdf42.jpg";